<template>
  <div class="narrow-padding item">
    <div class="ui basic buttons">
      <div
        v-for="(long, short) in languages"
        :key="short"
        @click="changeLanguage(short)"
        :style="{ color: short === $i18n.locale ? 'black !important' : '' } "
        class="ui compact basic button">
        {{ long }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguageToggle',
  computed: {
    id () {
      return 'language-toggle'
    },
    languages () {
      return {
        'en': this.$t('english'),
        'de': this.$t('german'),
        'fr': this.$t('french'),
        'es': this.$t('spanish')
      }
    }
  },
  methods: {
    changeLanguage (language) {
      this.$i18n.locale = language
    }
  }
}
</script>

<style scoped>
.narrow-padding {
  padding: 0.428571rem !important;
}
</style>
